import React, { useState, useEffect, useRef } from 'react'
import { toast } from 'react-toastify'

import api from '../../../../services/api'
import { getPermissions } from '../../../../services/auth'
import { useHistory } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'

import Render from './RegisterRender'

function Register ({ id }) {
  const history = useHistory()

  const [inputs, setInputs] = useState({})
  const [getLoading, setLoading] = useState(true)
  const [getAncoras, setAncoras] = useState([])

  const dispatch = useDispatch()

  const { lastGrid, filters } = useSelector(state => state.anchors)

  const ancorasLojasCodigosRef = useRef()

  const [getAncorasLojasCodigos, setAncorasLojasCodigos] = useState([])
  const [getAncorasLoadingCodigos, setAncorasLoadingCodigos] = useState(true)

  const getInfoForForm = async () => {
    try {
      const findAncoraLoja = await api.get(`AncorasLojas/ConsultarId?id=${id}`)
      const findAncoras = await api.get('Ancoras/Consultar')
      setInputs(findAncoraLoja.data.resposta)
      setAncoras(findAncoras.data.resposta)
      dispatch(CreatorsAnchors.changeLastAnchorStore(findAncoraLoja.data.resposta.nome))
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message)
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    }
    setLoading(false)
  }

  async function findAllAncorasLojasCodigos () {
    setAncorasLoadingCodigos(true)
    try {
      const anchorFilter = filters.find(x => x.anchor === 'ancoras-lojas-codigos')

      const response = await api.get(`AncorasLojasCodigos/ConsultarAncoraLojaId?id=${id}${anchorFilter.filter ? `&status=${anchorFilter.filter}` : ''}`)
      setAncorasLojasCodigos(response.data.resposta)
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message)
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    }
    setAncorasLoadingCodigos(false)
  }

  useEffect(() => {
    if (lastGrid !== 'ancoras-lojas-codigos') {
      dispatch(CreatorsAnchors.changeLastGrid('ancoras-lojas'))
    }
    const permissions = getPermissions({ moduloId: 1344, permissao: 'Alterar' })

    if (permissions) {
      getInfoForForm()
    } else {
      history.push('/app')
    }
  }, [])

  useEffect(() => {
    if (!getLoading) {
      if (lastGrid === 'ancoras-lojas-codigos') {
        dispatch(CreatorsAnchors.changeLastGrid('ancoras-lojas'))
        findAllAncorasLojasCodigos()
        ancorasLojasCodigosRef.current.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [getLoading])

  return <Render
    inputs={inputs}
    getLoading={getLoading}
    ancoralojaid={id}
    getAncoras={getAncoras}
    findAllAncorasLojasCodigos={findAllAncorasLojasCodigos}
    getAncorasLojasCodigos={getAncorasLojasCodigos}
    getAncorasLoadingCodigos={getAncorasLoadingCodigos}
    ancorasLojasCodigosRef={ancorasLojasCodigosRef}
    lastGrid={lastGrid}
  />
}

export default Register
